import React, { Fragment } from 'react';
import DisplayCode1 from '../../../../components/DisplayCode1/displayCode1';
import DisplayCode2 from '../../../../components/DisplayCode2/DisplayCode2';
import DisplayCodeKo from '../../../../components/DisplayCodeKo/DisplayCodeKo';

const check_out = () => {

  const codes = {
    answe_ok1: {
      title: "Answer ok",
      type: "json",
      code: `{
        "status":true,
        "codtran":"1dc6a14ff50f0410bca5f53b6a302a0a",
        "result":{
           "registry_id":1938,
           "event_type":"out"
        },
        "elapsed":0.3469808101654053
     }`,
      copied: false
    }
  };

  const codesMutiple = {
    selected: {
      id: "python",
      type: "python",
      code: ` import requestsurl = "http://34.121.95.179:80/ws/employee_time_control.py/check_out?country_code=ES&user_id=74&session_id=34242-7M94x6WvLh7-b19HC6PM_g==&company_code=YDmewfXYKSuxF32&latitude=40,6317525&logitude=-3,5859601"
    payload={}
    headers = { '101ObexApiKey': 'WcdoRNOUS8jQLs5XWo75yjwzvEZazcSI'}
    response = requests.request("GET", url, headers=headers, data=payload)
    print(response.text)`
    },
    options: [
      {
        id: "python",
        type: "python",
        code: ` import requestsurl = "http://34.121.95.179:80/ws/employee_time_control.py/check_out?country_code=ES&user_id=74&session_id=34242-7M94x6WvLh7-b19HC6PM_g==&company_code=YDmewfXYKSuxF32&latitude=40,6317525&logitude=-3,5859601"
    payload={}
    headers = { '101ObexApiKey': 'WcdoRNOUS8jQLs5XWo75yjwzvEZazcSI'}
    response = requests.request("GET", url, headers=headers, data=payload)
    print(response.text)`
      },
      {
        id: "nodejs",
        type: "javascript",
        code: ` var request = require('request');
  var options = {
  'method': 'GET',
  'url': 'http://34.121.95.179:80/ws/employee_time_control.py/check_out?country_code=ES&user_id=74&session_id=34242-7M94x6WvLh7-b19HC6PM_g==&company_code=YDmewfXYKSuxF32&latitude=40,6317525&logitude=-3,5859601',
  'headers': {
  '101ObexApiKey': 'WcdoRNOUS8jQLs5XWo75yjwzvEZazcSI'
  }
  };
  request(options, function (error, response) {
  if (error) throw new Error(error);
  console.log(response.body);
  });`
      },
      {
        id: "javascript",
        type: "javascript",
        code: ` var myHeaders = new Headers();
  myHeaders.append("101ObexApiKey", "WcdoRNOUS8jQLs5XWo75yjwzvEZazcSI");

  var requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow'
  };

  fetch("http://34.121.95.179:80/ws/employee_time_control.py/check_out?country_code=ES&user_id=74&session_id=34242-7M94x6WvLh7-b19HC6PM_g==&company_code=YDmewfXYKSuxF32&latitude=40,6317525&logitude=-3,5859601", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));'
  };

  fetch("http://34.121.95.179:80/ws/ws/orders.py/new?country_code=ES&user_id=133&session_id=1688-eEqteXomKai8aDW2GkUFZQ==&purchase_transaction_code=24&client_address=Calle sin numero&delivery_time=12:34:43&payment_operation_code=pi_968ac76f7d898e7&order_products_codes=[34001,34002,34003]&order_category_id=1200&delivery_type=takeout&client_email_address=correo@servidor.ext&order_prices=[10.0,11.0,9.0]&delivery_price=3.5&total_amount=33.5&purchase_detail=[\"hamburguesa\",\"ensalada\",\"cocacola\"]&gps_direction={\"lat\": 40,5431311,\"lng\": -3,6302845 }&contact=Manuel&order_amount=30 €&shipping_amount=3,5 €", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));`
      },
      {
        id: "curl",
        type: "bash",
        code: ` curl --location --request GET 'http://34.121.95.179:80/ws/employee_time_control.py/check_out?country_code=ES&user_id=74&session_id=34242-7M94x6WvLh7-b19HC6PM_g==&company_code=YDmewfXYKSuxF32&latitude=40,6317525&logitude=-3,5859601' \--header '101ObexApiKey: WcdoRNOUS8jQLs5XWo75yjwzvEZazcSI'`
      }
    ]
  }

  return (
    <Fragment>

      <div className='container-fluid row'>
        <div className='col-md-7'>
          <h1 >Check Out</h1>
          <h2 >
            ws/employee_time_control.py/check_out
          </h2>
          <h3 >Receives</h3>
          <p>
            All the parameters that the service receives must be indicated in the body
            of the request.
          </p>
          <div className='overflow-auto'>

            <table>
              <thead>
                <tr>
                  <th align="center">Parameter</th>
                  <th align="center">Format</th>
                  <th align="center">Obligatory</th>
                  <th align="center">Description</th>
                  <th align="center">Default value</th>
                  <th align="center">Example</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="center">country_code</td>
                  <td align="center">
                    ISO 3166 alpha-2 &#40;
                    <a href="https://www.iso.org/glossary-for-iso-3166.html">
                      https://www.iso.org/glossary-for-iso-3166.html
                    </a>
                    &#41;
                  </td>
                  <td align="center">Yes</td>
                  <td align="center">Country code in which the user resides</td>
                  <td align="center">N/A</td>
                  <td align="center">ES</td>
                </tr>
                <tr>
                  <td align="center">user_id</td>
                  <td align="center">Integer</td>
                  <td align="center">Yes</td>
                  <td align="center">Identifier of the user making the request</td>
                  <td align="center">N/A</td>
                  <td align="center">18</td>
                </tr>
                <tr>
                  <td align="center">session_id</td>
                  <td align="center">String</td>
                  <td align="center">
                    Yes &#40;if you do not send signature to &#39;Access
                    Service&#39;&#41;
                  </td>
                  <td align="center">
                    Obtained by identifying the user with ID user_id on the platform
                  </td>
                  <td align="center">N/A</td>
                  <td align="center">34242-7M94x6WvLh7-b19HC6PM_g==</td>
                </tr>
                <tr>
                  <td align="center">company_code</td>
                  <td align="center">String</td>
                  <td align="center">Only if user configuration requires</td>
                  <td align="center">The code from company</td>
                  <td align="center">N/A</td>
                  <td align="center">YDmewfXYKSuxF32</td>
                </tr>
                <tr>
                  <td align="center">latitude</td>
                  <td align="center">Float</td>
                  <td align="center">Only if user configuration requires</td>
                  <td align="center">Latitude of the user positioning</td>
                  <td align="center">N/A</td>
                  <td align="center">40,6317525</td>
                </tr>
                <tr>
                  <td align="center">longitude</td>
                  <td align="center">Float</td>
                  <td align="center">Only if user configuration requires</td>
                  <td align="center">Longitude of the user positioning</td>
                  <td align="center">N/A</td>
                  <td align="center">-3,5859601</td>
                </tr>
                <tr>
                  <td align="center">signature</td>
                  <td align="center">String</td>
                  <td align="center">
                    Yes &#40;if you do not send session_id to &#39;Access
                    Service&#39;&#41;
                  </td>
                  <td align="center">
                    Enables you to sign the request without having to log in
                  </td>
                  <td align="center">N/A</td>
                  <td align="center">328621ee3acda7a582338c5bba444c3094cd6f29</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2 >Returns:</h2>
          <p>
            Depending on the result of the operation, this service can return two
            different JSON:
          </p>

          <div className='mb-3'>
            <DisplayCode1 codeToshow={codes.answe_ok1} />
          </div>
          <h2 >Where:</h2>
          <ul>
            <li>
              <code>status:</code> Shows if the call has been successful
              &#40;true&#41; or not &#40;false&#41;.
            </li>
            <li>
              <code>result:</code> The registration result.
              <ul>
                <li>
                  <code>registry_id</code>: id code from registration process.
                </li>
                <li>
                  <code>event_type</code>: registration type &#40;in, out&#41;
                </li>
              </ul>
            </li>
            <li>
              <code>codtran:</code> Transaction code that identifies the executed
              operation.
            </li>
            <li>
              <code>elapsed:</code> Operation execution time.
            </li>
          </ul>
          <h3 >Answer JSON KO:</h3>

          <div className='mb-3'>
            <DisplayCodeKo />
          </div>

          <h2 >Business logic:</h2>
          <p>This service is used to record the end of a work day.</p>

        </div>
        <div className='col-md-5'>
          <h2 >Example requests:</h2>
          <div className='effectStickySections'>

            <div className='mb-3'>
              <DisplayCode2 codeToshow={codesMutiple} />
            </div>

          </div>

        </div>

      </div>

    </Fragment>
  );
}
export default check_out;
